<div class="order-cargo-details-view"> 
  <div *ngFor="let car of cars let index = index" class="flex flex__align-items--center">
      <div class="flex flex--column flex__align-self--center">
        <span>{{index + 1}}. {{ car.description }}</span>
        <!-- <img *ngIf="car.imageUrl" [src]="car.imageUrl" alt="carImage" class="actors--avatar"/> -->
      </div>
  </div>
</div>